var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgActivity = function SvgActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.862 12.142a.41.41 0 0 0 .41-.41v-2.77a.41.41 0 0 0-.41-.41h-2.008a.41.41 0 0 0-.41.41v2.77c0 .226.183.41.41.41h2.008Zm0 5.64a.41.41 0 0 0 .41-.41v-2.769a.41.41 0 0 0-.41-.41h-2.008a.41.41 0 0 0-.41.41v2.77c0 .226.183.41.41.41h2.008Zm-4.83-5.64a.41.41 0 0 0 .41-.41v-2.77a.41.41 0 0 0-.41-.41h-2.01a.41.41 0 0 0-.41.41v2.77c0 .226.184.41.41.41h2.01Zm0 5.64a.41.41 0 0 0 .41-.41v-2.769a.41.41 0 0 0-.41-.41h-2.01a.41.41 0 0 0-.41.41v2.77c0 .226.184.41.41.41h2.01Zm-6.044-14.09h14.91a.41.41 0 0 1 .41.41v23.795a.41.41 0 0 1-.41.41h-3.6v-5.242a.41.41 0 0 0-.41-.41h-2.01a.41.41 0 0 0-.41.41v4.832a.41.41 0 0 1-.41.41h-1.23a.41.41 0 0 1-.411-.41v-4.832a.41.41 0 0 0-.41-.41h-2.01a.41.41 0 0 0-.41.41v4.832a.41.41 0 0 1-.41.41h-3.19a.41.41 0 0 1-.41-.41V4.103a.41.41 0 0 1 .41-.41ZM3.857 14.846l6.013-4.513a.41.41 0 0 1 .656.328v17.237a.41.41 0 0 1-.41.41H4.102a.41.41 0 0 1-.41-.41V15.174c0-.13.061-.25.165-.328Z",
    fill: "#FCFAF8"
  })));
};

export default SvgActivity;